import api from "./Api";

class ReceberService {
  GetReceber(payload) {
    return api.get("/v1/receber/" + payload).then((response) => {
      return response.data;
    });
  }

  PostReceber(payload) {
    return api.post("/v1/receber/", payload).then((response) => {
      return response.data;
    });
  }

  PutReceber(payload) {
    return api.put("/v1/receber/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteReceber(payload) {
    return api.delete("/v1/receber/" + payload).then((response) => {
      return response.data;
    });
  }

  GetReceberOData(payload) {
    return api.get("/OData/Receber" + payload).then((response) => {
      return response.data;
    });
  }

  Estornar(payload) {
    return api
      .get("/v1/Receber/Estornar?guid_transacao=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ReceberRegistros(payload) {
    return api
      .post("/v1/Receber/ReceberRegistros/", payload)
      .then((response) => {
        return response.data;
      });
  }

  ReplicarRegistros(payload) {
    return api
      .post("/v1/Receber/ReplicarRegistros/", payload)
      .then((response) => {
        return response.data;
      });
  }

  RenegociarRegistros(payload) {
    return api
      .post("/v1/Receber/RenegociarRegistros/", payload)
      .then((response) => {
        return response.data;
      });
  }

  ImprimirRecibo(payload) {
    return api
      .post("/v1/Receber/ImprimirRecibo/", payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }

  GetRelatorio(payload) {
    return api.post("/v1/Receber/GetRelatorio", payload).then((response) => {
      return response.data;
    });
  }
}

export default new ReceberService();
